import {ApiRequest} from "../../../services/RequestService.tsx";
import RequestMethods from "../../../commons/enums/RequestMethods.tsx";
import UserAddressConstants from "../UserAddressConstants.ts";
import AddressModel from "../models/AddressModel.ts";

export const PointToAddressApiRequest = async (lat: number, lng: number) => {
    return await ApiRequest(`/api/map/address?latitude=${lat}&longitude=${lng}`, RequestMethods.GET);
}

export const GetAddressesListApiRequest = async (data: { page: number, count: number }) => {
    return await ApiRequest(UserAddressConstants.List, RequestMethods.POST, data);
}

export const CreateAddressApiRequest = async (data: AddressModel) => {
    return await ApiRequest(UserAddressConstants.Create, RequestMethods.POST, data);
}

export const UpdateAddressApiRequest = async (id: number, data: AddressModel) => {
    return await ApiRequest(UserAddressConstants.Update(id), RequestMethods.PUT, data);
}

export const RemoveAddressApiRequest = async (id: number) => {
    return await ApiRequest(UserAddressConstants.Delete(id), RequestMethods.DELETE);
}

export const CalculateAddressApiRequest = async (data: any) => {
    return await ApiRequest(UserAddressConstants.CalculateDeliveryPrice, RequestMethods.POST, data);
}